import { useFormContext, useWatch } from "react-hook-form";
import { Grid } from "@mui/material";
import { Input } from "@/components/elements/Input";
import { FormField } from "@/components/elements/FormField";
import { FCC } from "@/types/common";
import { TCaseBasicInfo } from "@/features/case/types/case";
import { Select } from "@/components/elements/Select";
import React, { useEffect, useState } from "react";
import { useGetUserListPersonInCharge } from "@/api/services/main/user";
import { useParams } from "react-router-dom";

type CaseBasicInfoFormProps = {
  disabled?: boolean;
  isCompleted?: boolean;
  isPersonInChargeLocked?: boolean;
};

export const CaseBaseInfoForm: FCC<CaseBasicInfoFormProps> = ({ disabled = false, isCompleted = false, isPersonInChargeLocked = false }) => {
  const methods = useFormContext<TCaseBasicInfo>();
  const { control } = methods;
  const personInChargeId = useWatch({ control, name: "personInChargeId" });
  const [validPersonInChanged, setValidPersonInChanged] = useState<number | null | undefined>();
  const { caseId } = useParams();

  const defaultPersonInChargeId = methods.formState.defaultValues?.personInChargeId;
  const selectedIdForOptions = caseId ? defaultPersonInChargeId : validPersonInChanged;
  const { userOptions } = useGetUserListPersonInCharge(selectedIdForOptions);

  const isNameDisabled = disabled || isCompleted;
  const isManagementNumberDisabled = disabled || isCompleted;
  const isPersonInChargeDisabled = disabled || isPersonInChargeLocked;

  useEffect(() => {
    if (!caseId) {
      const hasInUserList = userOptions.find((user) => user.value === personInChargeId);
      if (hasInUserList) {
        setValidPersonInChanged(personInChargeId);
      }
    }
  }, [personInChargeId]);
  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <FormField control={control} name="name">
          <Input readonly={isNameDisabled} />
        </FormField>
      </Grid>
      <Grid item xs={4}>
        <FormField control={control} name="managementNumber">
          <Input readonly={isManagementNumberDisabled} />
        </FormField>
      </Grid>
      <Grid item xs={4}>
        <FormField control={control} name="personInChargeId">
          <Select options={userOptions} isShowIconComponent={false} readonly={isPersonInChargeDisabled} />
        </FormField>
      </Grid>
    </Grid>
  );
};
